import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import client from "shared/utils/axios-config";

// Grant / revoke access to a purchased package. The server re-checks the
// business switch, the tier flag, the person cap and studio membership, so
// these are thin wrappers rather than a place to duplicate rules.
const invalidateSharing = (queryClient: ReturnType<typeof useQueryClient>) => {
  // The whole customer_package namespace: the detail page, the per-customer
  // lists, and every booking/schedule credit picker all change when access
  // does. Same blanket invalidation the purchase mutation uses.
  queryClient.invalidateQueries({ queryKey: ["customer_package"] });
  queryClient.invalidateQueries({ queryKey: ["customer"] });
};

export const useAddPackageMember = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (form: { customerPackageId: string; userId: string }) => {
      const res: AxiosResponse = await client.post(
        `/v1/customer_package/${form.customerPackageId}/members`,
        { user_id: form.userId },
      );
      return res.data;
    },
    onSuccess: () => invalidateSharing(queryClient),
  });
};

export const useRemovePackageMember = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (form: { customerPackageId: string; userId: string }) => {
      const res: AxiosResponse = await client.delete(
        `/v1/customer_package/${form.customerPackageId}/members/${form.userId}`,
      );
      return res.data;
    },
    onSuccess: () => invalidateSharing(queryClient),
  });
};
